import { isEmpty } from 'ramda';

import { isInternalItem } from 'store/itinerariesItem';
import { getHoursAndMinutes12, getHoursAndMinutes24 } from 'utils/date';

export const getCityCodeFormat = (code) => (code ? `(${code})` : '');

export const getMinutesAndHoursFormat = (date, utc, separator = 'h') => {
  const preparedUtc = parseFloat(Number(utc).toFixed(2));
  const utcFormat = Math.sign(preparedUtc) === -1 ? preparedUtc : `+${preparedUtc}`;
  const utcText = utc ? `| UTC${utcFormat}` : '';
  // const showTime = showTimeString(new Date(date));
  // const dateText = showTime ? `${getHoursAndMinutes12(date)} (${getHoursAndMinutes24(date)}) ${utcText}` : '';
  const dateText = `${getHoursAndMinutes12(date)} (${getHoursAndMinutes24(date, separator)}) ${utcText}`;

  return dateText;
};

export const getFilteredItems = (items) => items?.filter((item) => !isEmpty(item) && !isInternalItem(item));
